import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const CTA = () => (
  <section
    data-testid="cta-section"
    className="noise-overlay relative overflow-hidden bg-navy-950 bg-grid-dark py-24 md:py-36"
  >
    <div
      aria-hidden
      className="pointer-events-none absolute left-1/2 top-1/2 h-[380px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-electric/15 blur-[130px]"
    />
    <div className="relative mx-auto max-w-4xl px-6 text-center md:px-12">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-electric-bright">
          Let's Build Together
        </p>
        <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-white sm:text-5xl">
          Ready To Make Your Business{" "}
          <span className="text-gradient-blue">Smarter?</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate-400 md:text-lg">
          Let's turn your ideas, repetitive processes and business challenges into
          practical technology solutions.
        </p>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="#contact"
            data-testid="cta-book-consultation-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-electric px-8 py-4 font-medium text-white transition-[background-color,box-shadow,transform] duration-300 hover:scale-[1.02] hover:bg-electric-bright hover:shadow-[0_0_28px_rgba(37,99,235,0.5)] active:scale-95"
          >
            Book a Free Consultation
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <a
            href="#contact"
            data-testid="cta-contact-btn"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-8 py-4 font-medium text-white backdrop-blur-sm transition-[border-color,background-color] duration-300 hover:border-white/50 hover:bg-white/5"
          >
            Contact Prata Technologies
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTA;
